<template>
  <svg viewBox="0 0 101 100" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="0.5" width="100" height="100" rx="50" fill="#F4F5FA" />
    <g clip-path="url(#clip0_40003177_928)">
      <rect
        x="30.5"
        y="27.5"
        width="41"
        height="45.5"
        rx="13"
        fill="url(#paint0_linear_40003177_928)"
      />
      <path
        d="M53.4758 26.9565C61.1011 26.9565 64.9137 26.9565 67.5614 28.822C68.32 29.3565 68.9935 29.9904 69.5614 30.7044C71.5435 33.1963 71.5435 36.7847 71.5435 43.9614V49.9131C71.5435 56.8414 71.5435 60.3056 70.447 63.0724C68.6843 67.5204 64.9565 71.0289 60.2306 72.6879C57.2909 73.7198 53.6102 73.7198 46.2488 73.7198C42.0423 73.7198 39.939 73.7198 38.2592 73.1301C35.5586 72.1821 33.4285 70.1773 32.4212 67.6356C31.7947 66.0546 31.7947 64.075 31.7947 60.116V50.3382"
        stroke="#252525"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M71.5435 50.3384C71.5435 54.6428 68.054 58.1323 63.7496 58.1323C62.1929 58.1323 60.3576 57.8595 58.8441 58.265C57.4993 58.6254 56.4488 59.6758 56.0885 61.0206C55.6829 62.5342 55.9557 64.3694 55.9557 65.9261C55.9557 70.2306 52.4663 73.72 48.1618 73.72"
        stroke="#252525"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M45.8237 43.3237L37.6401 35.1401M37.6401 35.1401L29.4565 26.9565M37.6401 35.1401L45.8237 26.9565M37.6401 35.1401L29.4565 43.3237"
        stroke="#252525"
        stroke-width="2"
        stroke-linecap="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_40003177_928"
        x1="47.5"
        y1="44.5"
        x2="36.7345"
        y2="32.233"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <clipPath id="clip0_40003177_928">
        <rect width="44" height="48.7826" fill="white" transform="translate(28.5 26)" />
      </clipPath>
    </defs>
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
